import { Component, output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { InputText } from '@openng/optimus-ui/inputtext';
import { ButtonDirective } from '@openng/optimus-ui/button';

@Component({
  selector: 'app-external-contact-list-mobile-filter',
  templateUrl: './external-contact-list-mobile-filter.component.html',
  styleUrls: ['./external-contact-list-mobile-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    TranslateDirective,
    FormsModule,
    InputText,
    ButtonDirective,
    TranslatePipe,
  ],
})
export class ExternalContactListMobileFilterComponent {
  readonly mobileFilterEvent = output<any>();

  name!: string | null;

  mobileFilter() {
    this.mobileFilterEvent.emit({ name: this.name });
  }

  clear() {
    this.name = null;
    this.mobileFilter();
  }
}
